(function(){
  // grab slider wrapper and controls immediately
  var slider = document.getElementById('cross-sell-slider');
  var prevBtn = document.querySelector('.cross-sell-prev');
  var nextBtn = document.querySelector('.cross-sell-next');
  var idxEl   = document.querySelector('.cross-sell-index');
  var totEl   = document.querySelector('.cross-sell-total');
  if (!slider || !prevBtn || !nextBtn || !idxEl || !totEl) return;

  // the track is your <product-complimentary>
  var track = slider.querySelector('.cross_sell_products');
  if (!track) return;

  // poll until cards appear
  function init() {
    var cards = track.querySelectorAll('.cross-product-clip');
    if (cards.length === 0) {
      // try again in 150ms
      return setTimeout(init, 150);
    }

    // once we have cards, wire it up
    var current = 0;
    var total   = cards.length;
    totEl.textContent = total;

    function goTo(i) {
      current = (i + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      idxEl.textContent = current + 1;
    }

    prevBtn.addEventListener('click', function(){ goTo(current - 1); });
    nextBtn.addEventListener('click', function(){ goTo(current + 1); });

    // initial position
    goTo(0);
  }

  // kick off the polling
  init();
})();
